import { Box, Card, CardContent, CardMedia, Typography } from "@mui/material";
import axios from "axios";
import React, { useEffect, useState } from "react";

function Maps() {
  const [data, setData] = useState([]);

  useEffect(() => {
    axios.get(`https://overfast-api.tekrop.fr/gamemodes?locale=fr-fr`).then((res) => setData(res.data));
  }, []);

  return (
    <Box sx={{ marginTop: 2, marginBottom: 2, display: 'flex', flexWrap: 'wrap', justifyContent: 'center', alignItems: 'center', gap: 2 }}>
      {data.map((gamemode) => (
        <Card key={gamemode.name} sx={{ width: 345, minHeight: 400 }}>
          <CardMedia
            component="img"
            sx={{ height: 200, objectFit: 'cover' }} // Hauteur fixe et objectFit pour les images
            image={gamemode.screenshot}
            alt={gamemode.name}
          />

          <CardContent sx={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', p: 2 }}>
            <Box sx={{ display: 'flex', flexDirection: 'row', justifyContent: 'center', alignItems: 'center', gap: 1 }}>
              <Typography variant="h5" component="div" sx={{ textAlign: 'center', fontFamily: 'Kavit, sans-serif' }}>
                {gamemode.name}
              </Typography>
              <Box
                component="img"
                sx={{ width: 40, height: 40, borderRadius: '10px', backgroundColor: '#e4611c' }} // Taille fixe pour l'icône
                src={gamemode.icon}
                alt={gamemode.name}
              />
            </Box>
            <Typography sx={{ marginTop: 2, fontFamily: 'Oswald, sans-serif', fontWeight: 600, textAlign: 'center' }}>
              {gamemode.description}
            </Typography>
          </CardContent>
        </Card>
      ))}
    </Box>
  );
}

export default Maps;
